export const onboardingContent = {
  title: '要件ヒアリングの使い方',
  sections: [
    {
      heading: 'ここでは何をする？',
      image: '/images/help/source_notes/SS1.png',
      body: 'ヒアリングメモ（打ち合わせのメモや文字起こし）を入力すると、要件解析が始まり、概念モデル・要求・要件・業務フローが自動的に構造化されます。'
    },
    {
      heading: '入力のポイント',
      body: '断片的なメモでも構いません。生々しい会話内容がそのまま解析の材料になります。'
    },
    {
      heading: '次のステップ',
      body: '解析が終わったら「要件定義」画面で結果を確認・修正します。'
    }
  ]
}
